import React, { Component } from 'react';
import { AsyncCreatable } from 'react-select';

import axiosInstance from '../../../../../_helpers/axiosConfig';

class MedicationSearchType extends Component {
  constructor(props) {
    super(props);

    this.state = { selected: null }

    this.handleLoadOptions = this.handleLoadOptions.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selected) {
    this.setState({
      selected
    }, () => {
      this.props.dispatch(selected.map((select) => {
        return select.value
      }));
    });
  }

  handleLoadOptions(term, callback) {
    axiosInstance.request({
      url: `${process.env.REACT_APP_API_URL}/api/medications/quantities?search=${term}`,
      method: 'GET'
    })
      .then(function (response) {
        callback(response.data.map((medication) => {
          return { value: medication.Name, label: medication.Name }
        }));
      });
  }
  render() {
    return <AsyncCreatable
      loadOptions={this.handleLoadOptions}
      onChange={this.handleChange}
      value={this.state.selected}
      isMulti={true}
    />;
  }
}

export default MedicationSearchType;